import React, { FC } from 'react';
import AddIcon from '@material-ui/icons/AddCircle';

export const AddGuestPlayerButton: FC = () => {
  return (
    <>
      <AddIcon className="icon override" color="primary" fontSize="large" />

      <span className="text">ADD A GUEST PLAYER</span>
    </>
  );
};
